jQuery(document).ready(function($){
    //Fixed Add To Cart button in Product page
    function fixATC(){ 
        var atc_btn = $('.product_section .add_to_cart');
        var product_form = $('.product_right_section .shopify-product-form');
        if($(window).scrollTop() > product_form.offset().top){
            atc_btn.addClass('fixed_atc');
            $('body').addClass('fixed_atc_body');
        }
        else{
            atc_btn.removeClass('fixed_atc');
            $('body').removeClass('fixed_atc_body');
        }
    }

    $(document).on('click','.fixed_atc', function(e){
        e.preventDefault();
        e.stopPropagation();
        $("html, body").animate({ scrollTop: 0 }, "slow");
        return false;
    })

    $('.icon-cart').on('click', function(e){
        e.preventDefault();
        document.location.href = "/cart";
    })

    if($('body').hasClass('product-page')){
        $(window).scroll(fixATC);
        fixATC();
    }
    
    // Bundle option ATC button
    $('.bundle_atc-btn').on('click', function(e){
        e.preventDefault();

        var pack_value = $(this).data('value');
        var pack_cls = '.' + pack_value + '-swatch';

        $(pack_cls).find('label').trigger('click');
        $('.js-product_section #quantity').val(pack_value);

        $('.product_right_section .shopify-product-form .add_to_cart').trigger('click');
    })

    // Size tab link
    $(document).on('click', '.size_tab-links a', function(e){
        e.preventDefault();
        var tab_href = $(this).data('href');
        var tab_wrapper = $(this).closest('.size_chart-page').find('.size_tab-wrapper');
        tab_wrapper.removeClass('active');
        $('.size_tab-wrapper[data-tab="'+ tab_href +'"]').addClass('active');
        $('.size_tab-links a').removeClass('active');
        $(this).addClass('active');
    })



    // Logo bar slider mobile
    if($(window).width() < 768 ){
        if($('.logo-bar').length > 0){
            $('.logo-bar').flickity({
                // options
                cellAlign: 'left',
                contain: true
            });
        }
    }

    // CurrentDate 
    var fullDate = new Date()
    
    //convert month to 2 digits
    var twoDigitMonth = ("0" + (fullDate.getMonth() + 1)).slice(-2);
    
    var currentDate = twoDigitMonth + "/" + fullDate.getDate();
    $('.current_date').html(currentDate);
    // console.log(currentDate);
    //19/05/2011

    // Weglot_switcher.liquid
    // Weglot.initialize({ api_key:"wg_c6cee8aa13982aad9ea371032a2adc8b0" });

    // Knee high size cookie
    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
    
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
    
            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    };
    var knee_size = parseInt(getUrlParameter('R1'));
    if (knee_size > -1){
        Cookies.set('R1', knee_size);
    }
    // if( Cookies.get('R1') != undefined ){
    //     knee_size = parseInt(Cookies.get('R1'));
    //     jQuery(".product_form[data-product-type='restorative'] .single-option-selector[data-option='option1']").prop('selectedIndex', knee_size).trigger('change');
    //     console.log(knee_size);
    // }

    // hide 3,5 packs from the wiser 
    setTimeout(function(){
    $('.evm-wiser-variants option').each(function() {
        var string = $(this).html();
        var substring = "3";
        var substring1 = "5";
        if ( string.indexOf(substring) > -1 || string.indexOf(substring1) > -1) {
            $(this).remove();
        }
    });
    }, 5000);
})